const IconMinus = (): JSX.Element => {
  return (
    <>
      <path
        d="M19.5938 11.5005C19.5938 11.774 19.4851 12.0363 19.2917 12.2297C19.0983 12.4231 18.836 12.5317 18.5625 12.5317H3.4375C3.164 12.5317 2.90169 12.4231 2.7083 12.2297C2.5149 12.0363 2.40625 11.774 2.40625 11.5005C2.40625 11.227 2.5149 10.9647 2.7083 10.7713C2.90169 10.5779 3.164 10.4692 3.4375 10.4692H18.5625C18.836 10.4692 19.0983 10.5779 19.2917 10.7713C19.4851 10.9647 19.5938 11.227 19.5938 11.5005Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconMinus;
